import {
    Container,
    NineSlicePlane,
    Graphics,
    Rectangle
} from 'pixi.js';

import { ActiveButton } from './ActiveButton';
import { StyledBitmapText } from './StyledBitmapText';
import { Focusable } from './FocusManager';
import { LoadContext } from "../utils";

export class Switch extends Container implements Focusable
{
    private button:ActiveButton;
    private _isOn:boolean;
    protected focusBox: NineSlicePlane = null;
    protected offText: StyledBitmapText;
    protected onText: StyledBitmapText;

    public static preload(white = false)
    {
        if (white)
        {
            LoadContext.current.add('TitleAtlas', './assets/title/TitleAtlas{size}.json');
        }
        else
        {
            LoadContext.current.add('Settings', './assets/settings/Settings{size}.json');
        }
    }

    constructor(white = false)
    {
        super();
        const textStyle = {
            align: 'center',
            fontName: 'Asap',
            fontSize: 30,
            tint: white ? 0xffffff : 0x000000
        };

        

        this.offText = new StyledBitmapText( "OFF", textStyle );
        this.offText.anchor.set( 1, 0.6 );
        this.addChild( this.offText );

        this.onText = new StyledBitmapText( "ON", textStyle );
        this.onText.anchor.set( 0, 0.6 );
        this.onText.position.set( 180, 0 );
        this.addChild( this.onText );

        this.button = new ActiveButton(
            LoadContext.current.getTexture(white ? 'btn_switch_title0002' : 'btn_switch0002', white ? 'TitleAtlas' : 'Settings'),
            {
                content: '',
                style: null
            },
            LoadContext.current.getTexture(white ? 'btn_switch_title0001' : 'btn_switch0001', white ? 'TitleAtlas' : 'Settings'),
            {
                content: '',
                style: null
            }
        );
        this.button.position.set( 90, 0 );
        this.button.createHitRect(25);
        this.addChild( this.button );

        this.interactiveChildren = true;
        this.interactive = true;
        this.on('pointertap', () => {
            this.flipSwitch();
        });

         // after we are set up, make the focus -
        // allows subclasses to have their own size info or just override sprite
        setTimeout(this.createFocus.bind(this), 0);
    }

    public set isOn(value: boolean) {
        this._isOn = value;
        this.button.active = value;
    }

    public get isOn():boolean {
        return this._isOn;
    }

    private flipSwitch() {
        this.isOn = !this.isOn;
        this.emit( 'switchChanged', this.isOn );
    }

    // Focusable
    protected createFocus()
    {
        const FRAME_WIDTH = 6;

        this.focusBox = new NineSlicePlane(LoadContext.current.getSpritesheet('SharedUI').textures['highlight_frame'], FRAME_WIDTH, FRAME_WIDTH, FRAME_WIDTH, FRAME_WIDTH);
        const {width, height} = this.getSize();
        // make box just a tad bigger than whatever the size is
        this.focusBox.width = width + 2;
        this.focusBox.height = height + 20;
        this.focusBox.position.set(-64, -this.focusBox.height / 2);
        this.addChild(this.focusBox);
        this.focusBox.visible = false;
    }

    protected getSize()
    {
        return {width: 300, height: 80};
    }

    public get focus() { return this.focusBox.visible; }
    public set focus(focused) {
        this.focusBox.visible = focused;
        if (focused)
        {
            this.emit('pointerover');
        }
        else
        {
            this.emit('pointerout');
            this.emit('unfocused');
        }
    }

    public get focusVisible() { return this.focusBox.visible; }
    public set focusVisible(visible) {
        this.focusBox.visible = visible;
    }

    public activate()
    {
        this.flipSwitch();
    }

    destroy()
    {
        super.destroy({children: true});
    }
}